import getQuote from "./translations/en/get-quote"
import routes from "./translations/en/routes"
import newMortgage from "./translations/en/new-mortgage"
import renewal from "./translations/en/renewal"
import rates from "./translations/en/rates"
import landing from "./translations/en/landing"
import about from "./translations/en/about"
import footer from "./translations/en/footer"
import terms from "./translations/en/terms"
import privacy from "./translations/en/privacy"
import hero from "./translations/en/hero"
import faq from "./translations/en/faq"

export default {
  ...routes,
  ...landing,
  ...getQuote,
  ...newMortgage,
  ...renewal,
  ...rates,
  ...about,
  ...footer,
  ...terms,
  ...privacy,
  ...hero,
  nav: {
    how_it_works: "How It works",
    about: "About Nesto",
    jobs: "Jobs",
    number: "(613) 791-1798",
    numberFormatted: "6138589213",
    faq: "FAQ",
    faqLink: "/faq",
    getStarted: "GETTING A REVERSE MORTGAGE",
    terms_link: "Terms of Service",
    privacy_policy: "Privacy Policy",
    otherLanguage: "Français"
  },
  ...faq,
  calculator: {
    title: "Estimating how much cash you can get.",
    province: {
      title: "Which province do you live in?",
      placeholder: "Select"
    },
    town: {
      title: "Select a town",
      placeholder: "Select"
    },
    ageOfYoungestHomeOwner: {
      title: "What is the age of the youngest home owner?",
      placeholder: "Select"
    },
    estimatedValueOfYourHome: {
      title: "What is the estimated value of your home?",
      placeholder: "Minimum $250,000"
    },
    cta: "CONTINUE"
  }
}



// WEBPACK FOOTER //
// ./src/i18n/en.js